import { getV1UsersMeIamPermissions } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { Permission } from '~hooks/usePermissions/models';
import connection from '~services/connectionModule';
import { useStores } from '~store';

export default function usePermissions() {
  const { userStore } = useStores();

  const getPermissions = async () => {
    try {
      const response = await getV1UsersMeIamPermissions();
      const formatted = response.data.data.map(Permission.parse);

      userStore.setPermissions(formatted);

      return formatted;
    } catch (error) {
      connection.handleRequestError(
        error,
        t('error_messages.permissions.failed_to_fetch'),
      );
    }
  };

  return { getPermissions };
}
